"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealLactoseFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealLactoseFilled = function MealLactoseFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.281 14.967l5.053 5.054a4 4 0 010 5.657l-5.656 5.656a4 4 0 01-5.657 0l-5.054-5.053 11.314-11.314zm3.993-6.82a1 1 0 010 1.414L9.06 30.774a1 1 0 01-1.415-1.414L28.86 8.146a1 1 0 011.414 0zM15.07 9.413l1.656 1.655a6.003 6.003 0 016.726 1.072L12.14 23.451l-.084-.089a6.003 6.003 0 01-.988-6.635l-1.655-1.656a1 1 0 010-1.414l4.243-4.243a1 1 0 011.414 0zm-2.12-2.12a1 1 0 010 1.414L8.707 12.95a1 1 0 11-1.414-1.414l4.243-4.243a1 1 0 011.414 0z",
    fill: "#97BA1E"
  }));
};

exports.MealLactoseFilled = MealLactoseFilled;
var _default = MealLactoseFilled;
exports.default = _default;